import React, { useState } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MyMenuItem from '../models/MenuItem'
import { MenuItem } from '@mui/material';

interface MenuProps {
    menuItems: MyMenuItem[]
}

const MobileMenu: React.FC<MenuProps> = (props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseWithPath = (action: () => void) => {
        setAnchorEl(null);
        action();
    };

    return (
        <div>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon sx={{ color: '#fce5cc' }}>
                    <MenuRoundedIcon sx={{fontSize:50, marginLeft: '4px',justifyContent:'left'}}></MenuRoundedIcon>
                </ListItemIcon>
            </ListItemButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleClose}
                sx={{ height: '100%',   minHeight: '100%'}}
            >
                {props.menuItems.map((menuItem: MyMenuItem, index: React.Key | null | undefined) => (
                    <MenuItem sx={{fontSize:25}} onClick={() => handleCloseWithPath(menuItem.redirectTo)}>{menuItem.label}</MenuItem>
                ))}
            </Menu>

        </div>
    );
};

export default MobileMenu;
